module.exports = __webpack_public_path__ + "img/step7_gray.9ff7cae4.png";